import { render, staticRenderFns } from "./CategorySelectMenu.vue?vue&type=template&id=f4655732&scoped=true&"
import script from "./CategorySelectMenu.vue?vue&type=script&lang=js&"
export * from "./CategorySelectMenu.vue?vue&type=script&lang=js&"
import style0 from "./CategorySelectMenu.vue?vue&type=style&index=0&id=f4655732&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4655732",
  null
  
)

export default component.exports